import React, { useEffect, useState } from "react";
import { TabContent, TabPane } from 'reactstrap'


const PatientContent = (props) => {
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})

    useEffect(() => {
        setTabs(props.dynamicTabs)
        const activeComponent = props.subCategItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        if (activeComponent !== undefined) {
            setComponent(activeComponent)
        }
    }, [props.activeTab, props.subCategItems])
    return (
        <>
            {tabs.length > 0 ? (
                <>
                    <TabContent activeTab={props.activeTab}>
                        {tabs &&
                            tabs.map((item) => {
                                return (
                                    <React.Fragment key={item.key}>
                                        <TabPane tabId={item.key}>  {item.component && React.cloneElement(item.component, { Reload: props.Reload, id: props.dynamicTabs, ActivePatientID: props.ActivePatientID })}</TabPane>
                                    </React.Fragment>
                                )
                            })}
                    </TabContent>
                </>
            ) : (
                <TabContent activeTab={component.key}>
                    <React.Fragment key={component.key}>
                        <TabPane tabId={component.key}>  {component.component && React.cloneElement(component.component, { Reload: props.Reload, id: props.dynamicTabs, ActivePatientID: props.ActivePatientID })}</TabPane>
                    </React.Fragment>
                </TabContent>
            )}
        </>
    )
}

export default PatientContent